import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75.75h16.5s3 0 3 3v16.5s0 3-3 3H3.75s-3 0-3-3V3.75s0-3 3-3"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 6H6a1.5 1.5 0 0 0-1.5 1.5v6A1.5 1.5 0 0 0 6 15h3v1.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V15h3a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 18 6m-6 0v3.75M8.25 6v3.75M15.75 6v3.75"
    }, null, -1)
  ]));
}
const computerDeviceNetworkEthernetCat6 = { render };
export {
  computerDeviceNetworkEthernetCat6 as default,
  render
};
//# sourceMappingURL=computer-device-network-ethernet-cat6.svg.js.map
